import script from "./ChooseTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseTable.vue?vue&type=script&setup=true&lang=js"

import "./ChooseTable.vue?vue&type=style&index=0&id=e787b39e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e787b39e"]])

export default __exports__